"use strict";

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DonutChartGenerator = exports.DEFAULT_CONFIG_DONUT = exports.DEFAULT_COLORS_ODD = exports.DEFAULT_COLORS_EVEN = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _recharts = require("recharts");
var _excluded = ["data"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var DEFAULT_COLORS_EVEN = ['#D4D4D4', '#057EBD', '#0C3151', '#F78F49', '#79287C', '#7CC242', '#61479D'];
exports.DEFAULT_COLORS_EVEN = DEFAULT_COLORS_EVEN;
var DEFAULT_COLORS_ODD = ['#057EBD', '#0C3151', '#F78F49', '#79287C', '#7CC242', '#61479D', '#D4D4D4'];
exports.DEFAULT_COLORS_ODD = DEFAULT_COLORS_ODD;
var DEFAULT_CONFIG_DONUT = {
  // Styles used by the component and its children
  styles: {
    textColor: 'black',
    fontFamily: 'Nunito',
    fontWeight: 500,
    fontSize: '12px',
    cellPadding: 2,
    showTotalCount: false,
    textOverflowLength: 20
  },
  // Helper functions used by the component
  functions: {
    /**
     * Merge Props and return result of callback
     *
     * @param {object} props
     * @param {object} extraProps
     * @param {function} callback
     * @return {any} result of callback
     */
    mergeProps: function mergeProps(props, extraProps, callback) {
      return callback(_objectSpread(_objectSpread({}, props), extraProps));
    },
    /**
     * Return last index of dataset
     *
     * @param {object|array} dataset
     * @returns {number} last index of array
     */
    getLastIndex: function getLastIndex(dataset) {
      return dataset.length !== undefined ? dataset.length - 1 : 0;
    },
    /**
     * Map dataset to {name, value} pairs
     *
     * Note:
     * - Called by Array.map()
     *
     * @param {object} data
     * @returns {object} {name, value}
     */
    mapData: function mapData(data) {
      return {
        name: data.group,
        value: data.subjects
      };
    },
    /**
     * Generate an active shape element for the pie chart
     *
     * @param {*} props
     * @returns {JSX.Element}
     */
    renderActiveShape: function renderActiveShape(props) {
      var cx = props.cx,
        cy = props.cy,
        innerRadius = props.innerRadius,
        outerRadius = props.outerRadius,
        startAngle = props.startAngle,
        endAngle = props.endAngle,
        fill = props.fill,
        payload = props.payload,
        value = props.value,
        textColor = props.textColor,
        fontSize = props.fontSize,
        fontWeight = props.fontWeight,
        fontFamily = props.fontFamily,
        titleLocation = props.titleLocation,
        titleAlignment = props.titleAlignment,
        sliceTitle = props.sliceTitle,
        totalCount = props.totalCount,
        showTotalCount = props.showTotalCount,
        textOverflowLength = props.textOverflowLength;
      var isCapital = String(payload.name).toUpperCase() === String(payload.name);
      var overflowLength = isCapital ? textOverflowLength : textOverflowLength + 10;
      var labelX = titleAlignment === 'center' ? cx : titleAlignment === 'left' ? 0 : cx * 2;
      var labelY = titleLocation === 'top' ? 9 : cy * 2;
      var faceValue = showTotalCount === true ? "".concat(value, " / ").concat(totalCount) : value;
      return /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("text", {
        x: labelX,
        y: labelY,
        dy: 0,
        textAnchor: titleAlignment === 'center' ? 'middle' : undefined,
        fill: textColor,
        fontSize: fontSize || '12px',
        fontWeight: fontWeight || '500',
        fontFamily: fontFamily || 'Nunito',
        cursor: "text"
      }, String(payload.name).length > overflowLength ? "".concat(String(payload.name).substring(0, overflowLength), "...") : payload.name, /*#__PURE__*/_react.default.createElement("title", null, payload.name)), /*#__PURE__*/_react.default.createElement("text", {
        x: cx,
        y: cy,
        dy: 0,
        textAnchor: "middle",
        fill: textColor,
        fontSize: fontSize || '12px',
        fontWeight: "bold",
        fontFamily: fontFamily || 'Nunito'
      }, "".concat(faceValue)), /*#__PURE__*/_react.default.createElement("text", {
        x: cx,
        y: cy,
        dy: 12,
        textAnchor: "middle",
        fill: textColor,
        fontSize: fontSize || '12px',
        fontWeight: "light",
        fontFamily: fontFamily || 'Nunito'
      }, "".concat(sliceTitle)), /*#__PURE__*/_react.default.createElement(_recharts.Sector, {
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        startAngle: startAngle,
        endAngle: endAngle,
        fill: fill
      }), /*#__PURE__*/_react.default.createElement(_recharts.Sector, {
        cx: cx,
        cy: cy,
        startAngle: startAngle,
        endAngle: endAngle,
        innerRadius: outerRadius + 6,
        outerRadius: outerRadius + 8,
        fill: fill
      }));
    }
  },
  // Color scheme used for component slices
  colors: {
    even: DEFAULT_COLORS_EVEN,
    odd: DEFAULT_COLORS_ODD
  }
};

/**
 * Exposes a function to generate a donut chart component
 *
 * @param {object|null} uiConfig
 * @returns {object}
 */
exports.DEFAULT_CONFIG_DONUT = DEFAULT_CONFIG_DONUT;
var DonutChartGenerator = function DonutChartGenerator() {
  var uiConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_CONFIG_DONUT;
  var styles = uiConfig.styles,
    functions = uiConfig.functions,
    colors = uiConfig.colors;
  var _ref2 = styles && typeof styles === 'object' ? styles : DEFAULT_CONFIG_DONUT.styles,
    textColor = _ref2.textColor,
    fontFamily = _ref2.fontFamily,
    fontWeight = _ref2.fontWeight,
    fontSize = _ref2.fontSize,
    cellPadding = _ref2.cellPadding,
    showTotalCount = _ref2.showTotalCount,
    textOverflowLength = _ref2.textOverflowLength;
  var COLORS_EVEN = colors && colors.even instanceof Array && colors.even.length > 0 ? colors.even : DEFAULT_CONFIG_DONUT.colors.even;
  var COLORS_ODD = colors && colors.odd instanceof Array && colors.odd.length > 0 ? colors.even : DEFAULT_CONFIG_DONUT.colors.odd;
  var mergeProps = functions && typeof functions.mergeProps === 'function' ? functions.mergeProps : DEFAULT_CONFIG_DONUT.functions.mergeProps;
  var lastIndex = functions && typeof functions.getLastIndex === 'function' ? functions.getLastIndex : DEFAULT_CONFIG_DONUT.functions.getLastIndex;
  var mapDataset = functions && typeof functions.mapData === 'function' ? functions.mapDatasetObject : DEFAULT_CONFIG_DONUT.functions.mapData;
  var _activeShape = functions && typeof functions.renderActiveShape === 'function' ? functions.renderActiveShape : DEFAULT_CONFIG_DONUT.functions.renderActiveShape;
  return {
    DonutChart: function DonutChart(_ref) {
      var data = _ref.data,
        props = _objectWithoutProperties(_ref, _excluded);
      var cx = props.cx,
        cy = props.cy,
        titleLocation = props.titleLocation,
        titleAlignment = props.titleAlignment,
        sliceTitle = props.sliceTitle,
        blendStroke = props.blendStroke,
        innerRadius = props.innerRadius,
        outerRadius = props.outerRadius,
        width = props.width,
        height = props.height;
      var dataset = data.map(mapDataset);
      var totalCount = dataset.length || 0;
      var _ref3 = (0, _react.useState)(lastIndex(data)),
        _ref4 = _slicedToArray(_ref3, 2),
        activeIndex = _ref4[0],
        setActiveIndex = _ref4[1];
      var refHook = (0, _react.useRef)(data);
      (0, _react.useEffect)(function () {
        if ((0, _lodash.isEqual)(refHook.current, data) === false) {
          refHook.current = data;
          setActiveIndex(lastIndex(data));
        }
      }, [data]);
      var defaultProps = {
        textColor: textColor,
        titleLocation: titleLocation,
        titleAlignment: titleAlignment,
        sliceTitle: sliceTitle,
        fontSize: fontSize,
        fontWeight: fontWeight,
        fontFamily: fontFamily,
        totalCount: totalCount,
        showTotalCount: showTotalCount,
        textOverflowLength: textOverflowLength
      };
      return /*#__PURE__*/_react.default.createElement(_recharts.ResponsiveContainer, {
        width: width,
        height: height
      }, /*#__PURE__*/_react.default.createElement(_recharts.PieChart, null, /*#__PURE__*/_react.default.createElement(_recharts.Pie, {
        data: dataset,
        activeIndex: activeIndex,
        blendStroke: blendStroke || true,
        cx: cx || '50%',
        cy: cy || '50%',
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        dataKey: "value",
        paddingAngle: cellPadding,
        activeShape: function activeShape(currentProps) {
          return mergeProps(currentProps, defaultProps, _activeShape);
        },
        onMouseEnter: function onMouseEnter(d, idx) {
          return setActiveIndex(idx);
        }
      }, data.map(function (entry, index) {
        return /*#__PURE__*/_react.default.createElement(_recharts.Cell, {
          key: "cell-".concat(index),
          fill: data.length % 2 === 0 ? COLORS_EVEN[index % COLORS_EVEN.length] : COLORS_ODD[index % COLORS_ODD.length]
        });
      }))));
    }
  };
};
exports.DonutChartGenerator = DonutChartGenerator;
var _default = DonutChartGenerator;
exports.default = _default;